var map = {
	"./bowling_image.png": 4682,
	"./bowling_strike.gif": 948,
	"./bowling_swarm.gif": 8458,
	"./cc_crunchcards.png": 29,
	"./cc_gameplay.png": 1961,
	"./cc_materials.png": 4411,
	"./cc_taskcards.png": 933,
	"./cmyklash_anim.gif": 3207,
	"./cmyklash_title.png": 2725,
	"./dea_image.png": 4124,
	"./dea_splash.png": 8830,
	"./dea_style.png": 8036,
	"./ds_office_1.png": 2874,
	"./ds_office_2.png": 3985,
	"./ds_phone.png": 1616,
	"./ds_plants.png": 4200,
	"./ds_rocket.png": 6090,
	"./ds_transition.gif": 6788,
	"./ebg_1.gif": 455,
	"./ebg_2.gif": 3088,
	"./ebg_3.gif": 8937,
	"./ebg_4.gif": 2738,
	"./ebg_editor.png": 6658,
	"./froggen_bonk.gif": 4846,
	"./froggen_end.png": 5606,
	"./froggen_rain.gif": 1976,
	"./froggen_saw.gif": 9049,
	"./inf_inc_entrance.png": 8123,
	"./inf_inc_gameplay.gif": 9482,
	"./inf_inc_showroom.png": 8651,
	"./mit_rules.png": 6210,
	"./pattern_library/pl_homepage.png": 9612,
	"./pp_sketch.png": 2455,
	"./pp_tower.jpg": 8328,
	"./quack_baker.png": 5739,
	"./quack_baking.png": 8924,
	"./quack_home.png": 1727,
	"./quack_map.png": 1990,
	"./quack_spa.png": 2870,
	"./wrom_drain.gif": 3661,
	"./wrom_level.png": 1694,
	"./wrom_virus_1.png": 1015,
	"./wrom_virus_2.png": 956,
	"./wrom_virus_3.png": 53,
	"./wrom_virus_blink.gif": 4319
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4172;